// lib/cover-styles.ts
// Canonical art-style catalog — the single source of truth for the cover-compare
// lab. (The public style gallery was removed.)
export interface StyleCatalogEntry {
  id: string;
  name: string;
  description: string;
  isNew?: boolean;
}

export const STYLE_CATALOG: StyleCatalogEntry[] = [
  {
    id: 'cartoon',
    name: 'Cartoon',
    description: 'Bright, playful illustrations with bold outlines and vibrant colors, perfect for fun adventures and engaging young readers.',
    isNew: false
  },
  {
    id: 'watercolor',
    name: 'Watercolor',
    description: 'Soft, dreamy illustrations with a hand-painted feel, creating a warm and artistic atmosphere for gentle stories.',
    isNew: false
  },
  {
    id: 'realistic',
    name: 'Realistic',
    description: 'Detailed, lifelike illustrations that bring characters and scenes to life with stunning realism and depth.',
    isNew: false
  },
  {
    id: 'graphicnovel',
    name: 'Graphic Novel',
    description: 'Bold, dramatic comic book style illustrations with dynamic compositions and expressive character designs.',
    isNew: false
  },
  {
    id: 'enchantedwatercolor',
    name: 'Enchanted Watercolor',
    description: 'Whimsical, hand-painted illustrations featuring detailed environments and magical storytelling elements.',
    isNew: false
  },
  {
    id: 'modern3d',
    name: 'Modern 3D Animation',
    description: 'Contemporary computer-animated illustrations with vibrant colors and expressive characters.',
    isNew: false
  },
  {
    id: 'anime',
    name: 'Anime',
    description: 'Japanese animation style with expressive characters, dynamic poses, and vibrant storytelling.',
    isNew: true
  },
  {
    id: 'manga',
    name: 'Manga',
    description: 'Japanese comic book style with dramatic angles, expressive emotions, and distinctive visual flair.',
    isNew: true
  },
  {
    id: 'sketch',
    name: 'Sketch',
    description: 'Hand-drawn pencil sketch style with artistic shading and a timeless, classic feel.',
    isNew: true
  },
  {
    id: 'oil-painting',
    name: 'Oil Painting',
    description: 'Classic oil painting style with rich textures, deep colors, and masterful brushwork.',
    isNew: true
  },
  {
    id: 'pixel-art',
    name: 'Pixel Art',
    description: 'Retro 8-bit and 16-bit video game style, perfect for gaming enthusiasts and nostalgic charm.',
    isNew: true
  },
  {
    id: 'storybook',
    name: 'Classic Storybook',
    description: 'Traditional illustrated children\'s book style with timeless charm and warmth.',
    isNew: true
  },
  {
    id: 'pop-art',
    name: 'Pop Art',
    description: 'Bold, colorful pop art with graphic elements inspired by Andy Warhol and Roy Lichtenstein.',
    isNew: true
  },
  {
    id: 'impressionist',
    name: 'Impressionist',
    description: 'Soft brushstrokes and dreamy impressionist style inspired by Monet and Renoir.',
    isNew: true
  },
  {
    id: 'caricature',
    name: 'Caricature',
    description: 'Fun exaggerated features with playful proportions, perfect for humorous stories.',
    isNew: true
  }
];

/** Look up a catalog entry by id/slug OR display name (case-insensitive, trimmed). */
export function findCatalogStyle(nameOrId: string | undefined | null): StyleCatalogEntry | undefined {
  const k = (nameOrId || '').trim().toLowerCase();
  if (!k) return undefined;
  return STYLE_CATALOG.find(s => s.id.toLowerCase() === k || s.name.toLowerCase() === k);
}
